import { combineReducers } from 'redux';

import { router } from '../../routes';
import { authReducers } from './auth';
import { tasksReducer } from './tasks';
import { usersReducers } from './users';
import { modalReducer } from '../../modals';
import { commentsReducer } from './comments';
import { requestsReducers } from './requests';
import { contactsReducers } from './contacts';
import { companiesReducers } from './companies';
import { attachmentsReducer } from './attachments';
import { invitationsReducers } from './invitations';
import { requestLogsReducer } from './request-logs';
import { meetingNotesReducer } from './meeting-notes';
import { profileSettingsReducers } from './profile-settings';
import { initialLoadReducer, searchTermReducer } from './global';
import { organizationSettingsReducer } from './organization-settings';


export const reducers = combineReducers({
  router,
  auth: authReducers,
  modal: modalReducer,
  tasks: tasksReducer,
  users: usersReducers,
  logs: requestLogsReducer,
  comments: commentsReducer,
  requests: requestsReducers,
  contacts: contactsReducers,
  companies: companiesReducers,
  searchTerm: searchTermReducer,
  initialLoad: initialLoadReducer,
  attachments: attachmentsReducer,
  meetingNotes: meetingNotesReducer,
  invitationsUser: invitationsReducers,
  profileSettings: profileSettingsReducers,
  organizationSettings: organizationSettingsReducer,
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js